/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "Creating a new project will clear the current project. Are you sure you want to continue?" |
*
* @param {New_Project_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_text = /** @type {((inputs?: New_Project_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La creation d'un nouveau projet effacera le projet actuel. Voulez-vous continuer ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn Sie ein neues Projekt erstellen, wird das aktuelle Projekt gelöscht. Möchten Sie wirklich fortfahren?")
	if (locale === "it") return /** @type {LocalizedString} */ ("La creazione di un nuovo progetto cancellerà il progetto corrente. Vuoi continuare?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание нового проекта очистит текущий проект. Вы уверены, что хотите продолжить?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Al crear un nuevo proyecto, se borrará el proyecto actual. ¿Seguro que desea continuar?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新项目将会清除当前项目。您确定要继续吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいプロジェクトを作成すると、現在のプロジェクトがクリアされます。続行してもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया प्रोजेक्ट बनाने से मौजूदा प्रोजेक्ट हट जाएगा। क्या आप वाकई जारी रखना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar um novo projeto irá limpar o projeto atual. Tem certeza de que deseja continuar?")
	return /** @type {LocalizedString} */ ("Creating a new project will clear the current project. Are you sure you want to continue?")
});